module.exports = __webpack_public_path__ + "static/img/source-btn-bg.42337404.png";